import React from "react";
import cancelIcon from "../../assets/svg/Group 36.svg";
import backIcon from "../../assets/svg/Path 7.svg";
import nextIcon from "../../assets/svg/Path 6.svg";
import { computeHeadingLevel } from "@testing-library/dom";

export default function PopUp({
  nextPage,
  title,
  text,
  img,
  buttons,
  appear,
  handleCancel,
  children
}) {
  return (
    <>
      {appear ? (
        <div className="popUpBackground" onClick={handleCancel}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <img src={img} className="popUpImage" />
            <div className="popUpContent">
              <div className="pageControl">
                <div className="arrows">
                  <img src={nextIcon} onClick={() => nextPage(-1)} alt="" />
                  <img src={backIcon} onClick={() => nextPage(1)} alt="" />
                </div>
                <img src={cancelIcon} onClick={handleCancel} alt="" />
              </div>
              <h1 className="popUpTitle">{title}</h1>
              {text.map((el) => (
                <p className="popUpText">{el}</p>
              ))}
            {children}
              <div className="popUpButtons">
                {buttons.map(({ color, text }, i) => (
                  <button
                    className={"popUpButton " + (color ? color : "")}
                    onClick={i === 0 ? handleCancel : () => nextPage(1)}
                  >
                    {text}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
